__turbopack_context__.v({
  "className": "editorialnew_b9e02533-module__pI7Rha__className",
  "variable": "editorialnew_b9e02533-module__pI7Rha__variable",
});
